export default {"betTypeFilters":"rx-0p","select":"k1shT"};